module.exports = __webpack_public_path__ + "img/error.ade3548a.png";